import { CreateRoute } from "router/CreateRouter";
import { commonRoutes } from "router/routers/CommonRouter/routes";

export const CommonRouter = () => CreateRoute(commonRoutes);
